
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import { Toast } from 'vant'

export default {
components: {
Tab,
TabItem,
Divider,
Alert
},
data () {
return {
tabIndex:0,
pathCur:0,
model:{appId : this.$route.query.appId,pageSize:10,appPosition:2},
depAppLs:{},
excludesApps:{},
appChildLs:{},
appDbTypes:{},
appComment:{},
belongAppTypes:{},
list:{},
sumEvaluate:0,
patchs:{},
patchNumber:0,
index:0,
loading: false,
finished: false,
status: this.$route.query.status,
show:false,
message:"",
jtotal:-1,
linkFlag:0,
collectFlag:false,
productId:0,
productModel:{productId : this.productId}
}
},
created(){
this.addClick();
this.linkFlag=this.$route.query.linkFlag;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/getDetail',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.list=res.body.rows[0];
if(this.list.appDesc !=undefined){
this.list.appDesc=  this.list.appDesc.replace(/style="[^"]*?"/g,'');
this.list.appDesc= this.list.appDesc.replace(/height="[^"]*?"/g,'');
this.list.appDesc= this.list.appDesc.replace(/width="[^"]*?"/g,'');
this.list.appDesc= this.list.appDesc.replace(/img/g,'img width="100%" ');
}
this.depAppLs=res.body.depAppLs;
this.excludesApps=res.body.excludesApps;
this.appChildLs=res.body.appChildLs;
this.appDbTypes=res.body.appDbTypes;
this.belongAppTypes=res.body.belongAppTypes;
this.sumEvaluate=res.body.sumEvaluate;
this.patchNumber=res.body.patchNumber;
console.log(this.list);
}

this.productModel={productId : res.body.productId}
if(res.body.productId <= 0 ){
document.getElementsByClassName('phoneIcon')[0].style.width='50%';
document.getElementsByClassName('payBtn')[0].style.width='50%';
document.getElementsByClassName('freeTry')[0].style.display='none';
}

},function(res){
console.log(res.status);
});

this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/getPatchList',this.model,{emulateJSON:true}).then(function(res){
console.log(res.body);
if(res.body.code!=-1)
{
this.jtotal=0;
this.patchs=res.body.rows;
}
},function(res){
console.log(res.status);
});

},
methods: {
goBack(){
if(this.linkFlag==1){
window.history.go(-1);
}else{
app.goBack();
}
},
experience(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/goToLearn',this.productModel,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
if(res.body.learnRes.success){
app.experience(res.body.learnRes.mUrl, res.body.learnRes.appId, res.body.learnRes.pageId, res.body.learnRes.params, res.body.learnRes.token);
}else{
Toast(res.body.learnRes.message);
}
}
},function(res){
Toast('请求错误！');
});
},
call(){
app.callPhone("400-887-4949");
},
ShowColler(){
this.show=true
this.message="手机端暂不支持此功能。请移步至PC端操作"
},
getAppComment(){
this.tabIndex==1;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/getEvaluateList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.appComment=res.body.rows.rows;
if(this.appComment !=undefined){
this.appComment=  this.appComment.replace(/style="[^"]*?"/g,'');
this.appComment= this.appComment.replace(/height="[^"]*?"/g,'');
this.appComment= this.appComment.replace(/width="[^"]*?"/g,'');
this.appComment= this.appComment.replace(/img/g,'img width="100%" ');
}
}
},function(res){
console.log(res.status);
});
},
getPatch(){
this.tabIndex==2;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/getPatchList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.code!=-1)
{
this.jtotal=0;
this.patchs=res.body.rows;



}
},function(res){
console.log(res.status);
});
},
onLoad() {

setTimeout(() => {
this.model.pageSize=this.model.pageSize+10;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpaas/detail/getEvaluateList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.appComment=res.body.rows.rows;

this.loading = false;

if (this.appComment.length >= res.body.rows.total) {
this.finished = true;
}
}
},function(res){
console.log(res.status);
});
}, 500);
},
addClick(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mdoc/detail/addClickNumber',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{

}
},function(res){
console.log(res.status);
});
}
}
}



// WEBPACK FOOTER //
// ./src/views/ntalk/mall/paas/detail.vue